import {filesize} from 'filesize';

import BadgeRenderer from './BadgeRenderer';
import PublicationTitleRenderer from './PublicationTitleRenderer';

function numberFormatter(params) {
  return params.value ? params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : null;
}

function fileSizeFormatter(params) {
  return filesize(params.value, {standard: 'jedec'});
}

export default function columnsDefs(tab) {
  const columns = [
    {
      headerName: 'Sequencing Types',
      field: 'seqTypes',
      minWidth: 180,
      cellRenderer: BadgeRenderer,
      resizable: true,
      sortable: true,
      flex: 2,
    },
    {
      headerName: 'File Types',
      field: 'fileTypes',
      minWidth: 325,
      cellRenderer: BadgeRenderer,
      resizable: true,
      sortable: true,
      flex: 2,
    },
    {
      headerName: 'Total Files',
      field: 'totalFileCount',
      valueFormatter: numberFormatter,
      minWidth: 100,
      resizable: true,
      sortable: true,
      flex: 1,
    },
    {
      headerName: 'Total File Size',
      field: 'totalFileSize',
      valueFormatter: fileSizeFormatter,
      flex: 1,
      resizable: true,
      comparator: (valueA, valueB) => valueA - valueB,
      sortable: true,
    },
  ];

  const diseasesNameCol = {
    headerName: 'Primary Diagnosis',
    field: 'name',
    minWidth: 200,
    resizable: true,
    sortable: true,
    flex: 2,
  };

  const associatedDiagnosisNameCol = {
    headerName: 'Associated Diagnosis',
    field: 'name',
    minWidth: 200,
    resizable: true,
    sortable: true,
    flex: 2,
  };

  const publicationsNameCol = {
    headerName: 'Publication',
    field: 'name',
    cellRenderer: PublicationTitleRenderer,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flex: 4,
  };

  const cohortsNameCol = {
    headerName: 'Dataset',
    field: 'name',
    minWidth: 150,
    resizable: true,
    sortable: true,
    flex: 2,
  };

  const cohortsAccessionCol = {
    headerName: 'Accession Number',
    field: 'accessionNumber',
    minWidth: 150,
    resizable: true,
    sortable: true,
    sort: 'asc',
    flex: 1,
  };

  const samplesNameCol = {
    headerName: 'Sample Name',
    field: 'name',
    minWidth: 120,
    resizable: true,
    sortable: true,
    flex: 1,
  };

  const samplesCol = {
    headerName: 'Samples',
    field: 'totalSampleCount',
    valueFormatter: numberFormatter,
    minWidth: 90,
    resizable: true,
    sortable: true,
    flex: 1,
  };

  switch (tab) {
    case 'tumor':
    case 'paired-tumor-normal':
      columns.splice(0, 0, diseasesNameCol);
      columns.splice(3, 0, samplesCol);
      break;
    case 'germline':
      columns.splice(0, 0, associatedDiagnosisNameCol);
      columns.splice(3, 0, samplesCol);
      break;
    case 'publications':
      columns.splice(0, 0, publicationsNameCol);
      columns.splice(3, 0, samplesCol);
      break;
    case 'cohorts':
      columns.splice(0, 0, cohortsNameCol);
      columns.splice(1, 0, cohortsAccessionCol);
      columns.splice(4, 0, samplesCol);
      break;
    case 'samples':
      columns.splice(0, 0, samplesNameCol);
      break;
  }

  return columns;
}
